import styles from "./Warning.module.css";
import classNames from "classnames";
import { CalculatorWarning } from "../../../state";
import { useI18n } from "../../../i18n";
import { WarningIcon } from "../../../assets/icons/WarningIcon";
import { AttentionIcon } from "../../../assets/icons/AttentionIcon";

import type { JSX } from "react";

type WarningProps = CalculatorWarning;

const Warning = (props: WarningProps): JSX.Element => {
  const { isCritical, messageKey, payload } = props;
  const { t } = useI18n();

  const warningClassNames = classNames(styles.warning, { [styles.isCritical]: isCritical });
  const warningId = props.belongsTo + "_warning";
  return (
    <div className={warningClassNames}>
      <div className={styles.iconWrapper}>
        {isCritical ? <AttentionIcon className={styles.icon} /> : <WarningIcon className={styles.icon} />}
      </div>
      <span role="alert" id={warningId}>
        {t(messageKey, payload)}
      </span>
    </div>
  );
};

export { Warning };
